import SectionHeading from '@/pages/home/components/SectionHeading';
import { virusAnalysis } from '@/mocks/home';

const toneMap: Record<string, { bg: string; text: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-800' },
};

export default function VirusSection() {
  return (
    <section id="virus" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10 items-start">
          <div className="lg:col-span-1">
            <SectionHeading
              eyebrow="病毒与恶意软件"
              title="神马影院有病毒吗？"
              desc="“会不会中毒”是很多人最直接的担心。结论是：风险基本都集中在“下载什么、点了什么”，而不是“打开了网页”。"
            />
            <div className="mt-6 p-5 rounded-lg bg-primary-50 border border-primary-200">
              <p className="text-sm text-foreground-700 leading-relaxed">
                换句话说，<strong className="text-primary-700 font-semibold">不下载、不安装、不乱授权</strong>，
                就能把绝大多数所谓的“病毒风险”挡在门外。
              </p>
            </div>
          </div>

          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {virusAnalysis.map((v) => {
              const tone = toneMap[v.tone] ?? toneMap.accent;
              return (
                <div key={v.title} className="p-5 rounded-lg bg-background-50 border border-background-200">
                  <span className={`w-10 h-10 flex items-center justify-center rounded-md ${tone.bg} ${tone.text} mb-4`}>
                    <i className={`${v.icon} text-lg`}></i>
                  </span>
                  <h3 className="font-heading font-semibold text-foreground-950 text-base mb-2">{v.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{v.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}